import { AppUiRecordDoc } from '@omni/interfaces/app-ui/record.interface';
import { isSubmitPending } from '@omni/data-services/app-ui/app-ui-record.data.service';
import { SalesOrderState } from '@omni/enums/order-capture/sales-order.enum';
import { syncStatusKey } from '@omni/services/app-ui/app-ui-screen-controller';

/**
 * A device order's status for the rep: Submitted from the moment they submit, else how its save
 * went. Its own module so the account feed can label device orders without loading the order engine.
 */
export function deviceOrderStatusKey(record: AppUiRecordDoc): string {
  if (deviceOrderState(record) === SalesOrderState.Submitted)
    return 'SUBMITTED';
  const key = syncStatusKey(record);
  // Waiting to go or gone, a draft reads as a draft, as on its screen: never "Saving…".
  return key === 'APP_UI_SYNC_PENDING' || key === 'APP_UI_SYNC_LANDED'
    ? 'APP_UI_SYNC_DRAFT'
    : key;
}

/** The order's `statecode` as the server will have it: Submitted from the moment the rep submits. */
export function deviceOrderState(record: AppUiRecordDoc): SalesOrderState {
  // A Submit that gave up leaves its request on the record; the order is still open.
  return record.submitted || isSubmitPending(record)
    ? SalesOrderState.Submitted
    : SalesOrderState.Active;
}
